<template>
<div>
    <div v-show="!isEditing">
        <div>
            <div class="card-header">
                <p class="card-header-title">{{ data.name }}</p>
            </div>
            <footer class="card-footer">
                <a href="#" class="card-footer-item manage-students-button-bg" v-on:click="goManageStudents(data)">Manage List</a>
                <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
                <a href="#" class="card-footer-item" v-on:click="deleteData(data)">Delete</a>
            </footer>
        </div>
    </div>

    <div v-show="isEditing">        
        <div class="card-header">
            <p class="card-header-title">Edit Group</p>
        </div>
        <div class="card-content">
            <div class="content">
                <div class="field">
                    <input class="input is-success" type="text" placeholder="Group Name" v-model="data.name">
                </div>
                <div class="field">
                    <multiselect v-model="data.teachers" :options="listTeachers" :close-on-select="false" :multiple="true" :hide-selected="true" label="firstName" track-by="firstName" placeholder="Select the teachers for this group"></multiselect>
                </div>
                <div class="field">
                    <b-radio v-model="data.status" native-value="1">
                        Active
                    </b-radio>
                    <b-radio v-model="data.status" native-value="0">
                        Inactive
                    </b-radio>
                </div>
                <div class="field">
                    <button class='button is-primary' v-on:click="updateData(data)">Update</button>
                    <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    props: ['data'],
    components:{
        Multiselect,
        Loading,
    },
    data() {
        return {
            listTeachers: [{
                _id: '',
                firstName: ''
            }],
            name: '',
            teachers: [],
            status: 1,
            isEditing: false
        };
    },
    created() {
        this.getTeacherList();
    },
    methods: {
        getTeacherList(){
            console.log("entering getTeacherList")
            let self = this;
            
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/teachers/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                // JSON responses are automatically parsed.
                self.listTeachers = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data) {
            this.$emit('update-data', data);
            this.isEditing = false;
        },        
        goManageStudents(data){
            console.log("entering goManageStudents with")
            console.log(data)
            
            this.$store.commit('UPDATE_VIEW_GROUP_ID',data._id)
            this.$store.commit('UPDATE_VIEW_GROUP_NAME',data.name)
            localStorage.setItem('VIEW_GROUP_ID',data._id)
            localStorage.setItem('VIEW_GROUP_NAME',data.name)
            this.$router.push({
                name: "ManageGroupsStudents"
            });
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.myLabel{
    float: left;
    width: 15%;
    padding: 5px;
}
.badgeDropdown{
    width: 300px;
}
.badgeImage{
    width: 50px;
}
.badgeTitle{
    padding-top: 30px !important;
    float: right;
}
.myInput{
    float: left;
    width: 80%;
    padding: 5px;
}
.manage-students-button-bg{
    background-color: #bb49d4;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/Groups/DataView.vue